import * as d3 from 'd3'

export default {
  methods: {

    chart_Controller(selection, props) {

      let actData = props.dataSet.filter(f=> f.CDATE <= this.cutoff)

      // Bar Chart 
      let st = this.chart.styles.find(f=> f.type == 'UP')
      this.draw_BarChart_Up(selection, actData, st) // -----> below

      st = this.chart.styles.find(f=> f.type == 'DOWN')
      this.draw_BarChart_Down(selection, actData, st) // -----> below


      // Line Chart 
      this.chart.styles.filter(f=> f.type == 'LINE').forEach((st,i)=> {
        this.draw_LineChart(selection, actData, st) // -----> below
        if(this.chart.lastValue > 0) this.draw_lastValue(selection, actData, st) // -----> below
      })
    },


    draw_BarChart_Up(selection, _data, _st) {
      
      _data.forEach((d,i)=> {
        
        let value = (d[_st.code] < 0) ? 0 : d[_st.code]

        selection
        .append('rect')
        .attr('x', d.mx - _st.size/2)
        .attr('y', (this.chart.height/2)-this.primary.axis(value))
        .attr('width', _st.size).attr('height', this.primary.axis(value))
        .attr('fill', _st.color).attr('opacity', _st.opacity)

        if(_st.vSize > 0 && value > 0) {
          selection
          .append('text')
          .attr('x', d.mx)
          .attr('y', (this.chart.height/2)-this.primary.axis(value) -2)
          .attr('font-size', _st.vSize).attr('fill',  _st.vColor)
          .attr('text-anchor', 'middle')
          .text(value)
        }
      })
    },

    draw_BarChart_Down(selection, _data, _st) {
      
      _data.forEach((d,i)=> {
        
        let value = (d[_st.code] < 0) ? 0 : d[_st.code]

        selection
        .append('rect')
        .attr('x', d.mx - _st.size/2)
        .attr('y', this.chart.height/2)
        .attr('width', _st.size).attr('height', this.primary.axis(value))
        .attr('fill', _st.color).attr('opacity', _st.opacity)

        if(_st.vSize > 0 && value > 0) {
          selection
          .append('text')
          .attr('x', d.mx)
          .attr('y', this.chart.height/2 + this.primary.axis(value) + 2 + _st.vSize*0.75)
          .attr('font-size', _st.vSize).attr('fill',  _st.vColor)
          .attr('text-anchor', 'middle')
          .text(value)
        }
      })
    },


    draw_LineChart(selection, _data, _st) {
      let lineFunc = d3.line()
      .x(d => d.mx)
      .y(d => this.secondary.axis(d[_st.code]))

      selection
      .append('path')
      .attr('d', lineFunc(_data))
      .attr('stroke', _st.color).attr('stroke-width', _st.size)
      .attr('fill', 'none').attr('opacity', _st.opacity)
      .style("stroke-dasharray", (_st.ltype, _st.ltype))

      _data.forEach((d,i)=> {
        // Node
        if(_st.node > 0) {
          selection
          .append('circle')
          .attr('cx', d.mx)
          .attr('cy', this.secondary.axis(d[_st.code]))
          .attr('r', _st.node)
          .attr('fill', _st.color).attr('opacity', _st.opacity)
        }
        // Value
        if(_st.vSize > 0 && d[_st.code] > 0) {
          selection
          .append('text')
          .attr('x', d.mx)
          .attr('y', this.secondary.axis(d[_st.code]) -4)
          .attr('font-size', _st.vSize).attr('fill',  _st.vColor)
          .attr('text-anchor', 'middle')
          .text(d[_st.code])
        }
      })
    },


    draw_lastValue(selection, _data, _st) {
      // draw the final value
      let lastOne = null
      lastOne = _data.find(f=> f.CDATE == this.cutoff)
        
      if(_st.type == 'LINE') {
        if(!lastOne) return
        selection
        .append('text')
        .attr('x', lastOne.mx + 5)
        .attr('y', this.secondary.axis(lastOne[_st.code]) + 1 + this.chart.lastValue*0.26)
        .attr('font-size', this.chart.lastValue).attr('fill',  _st.vColor)
        .text(lastOne[_st.code])
      }
    },

  }
}